import step0Info from '../../../share/communication/step0-info'
import step1Products from '../../../share/communication/step1-products'
import step2Actions from '../../../share/communication/step2-actions'
import recallService from '../../../../services/provider/recall'
import changeHistory from '../../../share/communication/change-history'
import router from '../../../../router/paths'
import { COMMUNICATION_TYPE, EMPTY_GUID } from '../../../../misc/commons'
import siteService from '../../../../services/provider/sites'
import userServices from '../../../../services/user'
import _ from 'lodash'
import { getParentOrgType } from '../../../../misc/auth'
import organizationService from '../../../../services/provider/organization'
import recallReviewServices from '../../../../services/notisphere/recallReview'
import recallsFeedServices from '../../../../services/notisphere/recalls-feed'
import supplierRecallService from '../../../../services/supplier/supplier-recall'
export const step = [
    {
        id: '',
        name: 'Recall',
        order: 1
    },
    {
        id: '',
        name: 'Products',
        order: 2
    },
    {
        id: '',
        name: 'Actions',
        order: 3
    }
]

export default {
    data() {
        return {
            loading: false,
            initialLoading: true,
            isAddProduct: false,
            recallStep: step,
            currentStep: 0,
            recallMode: localStorage.getItem('recallMode'),
            communicationType: COMMUNICATION_TYPE.RECALL,
            recallItem: {
                id: '',
                name: '',
                communicationName: '',
                suppilerName: '',
                notifiedDate: '',
                responseEmail: '',
                communicationUID: '',
                type: '',
                communicationDate: '',
                classification: '',
                zNumber: '',
                status: '',
                isUrgent: false,
                markAs: '',
                supplierId: 0,
                alphaCode: '',
                supplierName: '',
                createdBy: '',
                image: null,
                description: '',
                publicId: '',
                riskToHealth: '',
                typeAction: '',
                categories: [],
                documents: [],
                products: [],
                actions: [],
                meta_data: null,
                site: null,
                supplierRepCCEmails: null,
                additionalCcEmails: null,
                dueDate: null,
                isCreatedFromRecallFeed: false,
                recallFeedDocuments: []
            },
            recallMetaData: {
                recall_types: [],
                recall_categories: [],
                recall_mark_as: [],
                recall_product_fields: [],
                recall_usersites: [],
            },
            routeFormType: '',
            recallEditPathName: router.prov_Recall_EditItem.name,
            recallNewPathName: router.prov_Recall_NewItem.name,
            recallSupplierListPathName: router.prov_Recall.name,
            changeHistoryModalKey: 0,
            autonotifychecked: false,
            SupplierContactlst: [],
            providerCommunicationId: '',
            communicationId: '',
            buttonType: '',
            needsEmailInitialization: false,
            recallsite: [],
            feedRecallSourceId: null,
            isAutoPopulateLeaveGuardBypass: false,
            isAutoPopulateLeaveConfirmOpen: false,
            aiRecallJobId: null,
            isAutoPopulateEditInProgress: false,
            isAiRecallSaved: false
        }
    },
    components: {
        step0Info,
        step1Products,
        step2Actions,
        changeHistory
    },
    computed: {
        isDisabled() {
            if (!this.recallItem) {
                return true
            }
            else {
                return false
            }
        }
    },
    created() {
        this.feedRecallSourceId = this.$route.params.recallFeedSourceId
        this.aiRecallJobId = this.$route.params.aiRecallJobId
        this.isAiRecallSaved = this.$route.params.isAiRecallSaved || false
        if((this.aiRecallJobId || this.feedRecallSourceId) && !this.$route.params.step) {
            this.initialLoading = true
            this.routeFormType = 'CREATE'
            if(this.aiRecallJobId) {
                recallService.getRecallAIByJobId(this.aiRecallJobId).then(resp => {
                    this.mapRecallFeedToRecallItem(resp.data.recall_info)
                    this.recallItem.recallFeedDocuments =
                        (resp.data.latest_documents && resp.data.latest_documents.length)
                            ? resp.data.latest_documents
                            : (resp.data.documents || [])
                    this.fetchRecallMetaDataFromService()
                })
            } else {
                this.fetchRecallFeedData(this.feedRecallSourceId).then(recallFeed => {
                    this.mapRecallFeedToRecallItem(recallFeed.recall_info)
                    this.recallItem.recallFeedDocuments =
                        (recallFeed.latest_documents && recallFeed.latest_documents.length)
                            ? recallFeed.latest_documents
                            : (recallFeed.documents || [])
                    this.fetchRecallMetaDataFromService()
                }).finally(() => {
                    this.initialLoading = false
                })
            }
        } else if (this.$route.name === this.recallEditPathName && this.$route.params && this.$route.params.id) {
            this.initialLoading = true
            this.communicationId = this.$route.params.id
            const autoPopulateRecallId = localStorage.getItem('autoPopulateRecallId')
            if (autoPopulateRecallId && autoPopulateRecallId === this.$route.params.id) {
                this.isAutoPopulateEditInProgress = true
            }
            this.providerCommunicationId = this.$route.params.providerCommunicationId==undefined?0:this.$route.params.providerCommunicationId
            let providerCommunicationId=this.$route.params.providerCommunicationId==undefined?0:this.$route.params.providerCommunicationId
            if(this.providerCommunicationId==0){
                this.fetchProviderCommunicationId().then((res) => {
                    providerCommunicationId = this.providerCommunicationId
                })
            }
            this.fetchRecallItemDetail(this.$route.params.id,providerCommunicationId).then(res => {
                if (res) {
                    this.routeFormType = 'EDIT'
                    if (this.$route.params.step) {
                        this.currentStep = this.$route.params.step
                    }
                    this.initialLoading = false
                }
            })
        } else {
            this.routeFormType = 'CREATE'
            this.fetchRecallMetaDataFromService()
        }
        this.getUserSiteforRecallMeta()
        this.getAutoNotifySetting()
    },
    beforeRouteLeave(to, from, next) {
        if (this.isAutoPopulateLeaveGuardBypass || !this.hasPendingAutoPopulatedRecall()) {
            next()
            return
        }

        if (this.isAutoPopulateLeaveConfirmOpen) {
            next(false)
            return
        }

        this.isAutoPopulateLeaveConfirmOpen = true
        this._showConfirm(
            'Do you want to save details before moving away from this page?',
            {
                title: 'Unsaved Changes',
                variant: 'warning',
                saveLabel: 'Yes',
                cancelLabel: 'No'
            }
        ).then(async (shouldSave) => {
            if (shouldSave) {
                const saved = await this.saveAutoPopulatedRecallBeforeLeave()
                if (!saved) {
                    next(false)
                    return
                }
            } else {
                this.clearAutoPopulatedProcessedData()
            }
            this.isAutoPopulateLeaveGuardBypass = true
            next()
        }).catch(() => {
            next(false)
        }).finally(() => {
            this.isAutoPopulateLeaveConfirmOpen = false
        })
    },
    methods: {
        hasPendingAutoPopulatedRecall() {
            return (
                (Boolean(this.feedRecallSourceId) || Boolean(this.aiRecallJobId)) &&
                this.routeFormType === 'CREATE' &&
                !this.communicationId &&
                !(this.recallItem && this.recallItem.id && this.recallItem.id !== EMPTY_GUID)
            ) || this.isAutoPopulateEditInProgress
        },
        async saveAutoPopulatedRecallBeforeLeave() {
            // Handle EDIT page case (steps 1 or 2 after auto-populate)
            if (this.isAutoPopulateEditInProgress) {
                try {
                    let saved = true
                    if (this.currentStep === 1 && this.$refs.step1Products) {
                        saved = await this.saveStep1Products('nextStep', this.recallMode)
                    } else if (this.currentStep === 2 && this.$refs.step2Actions) {
                        saved = await this.saveStep2Actions('nextStep', this.recallMode)
                    }
                    if (!saved) { return false }
                    localStorage.removeItem('autoPopulateRecallId')
                    return true
                } catch (e) {
                    return false
                }
            }
            // Handle CREATE page case (step 0)
            if (!this.$refs.step0Info || typeof this.$refs.step0Info.save !== 'function') {
                return false
            }
            try {
                const recallId = await this.saveAllRecallData(this.nextStep, this.currentStep, 'nextStep', this.recallMode, true)
                if (!recallId) { return false }
                this.communicationId = recallId
                const recallFeedId = localStorage.getItem('RecallFeedId')
                if (recallFeedId) {
                    localStorage.removeItem('RecallFeedId')
                    this.updateRecallStatus(recallFeedId, 'CREATED')
                }
                return true
            } catch (e) {
                return false
            }
        },
        clearAutoPopulatedProcessedData() {
            const recallFeedId = localStorage.getItem('RecallFeedId')
            if (recallFeedId) {
                this.updateRecallStatus(recallFeedId, 'PENDING')
            }
            localStorage.removeItem('RecallFeedSourceId')
            localStorage.removeItem('RecallFeedId')
            localStorage.removeItem('savedStep')
            localStorage.removeItem('autoPopulateRecallId')
        },
        fetchRecallFeedData(sourceId) {
            return new Promise((resolve, reject) => {
                recallReviewServices.getRecallReviewById(sourceId).then(resp => {
                    if (resp && resp.data && resp.data.d && resp.data.d.data) {
                        resolve(resp.data.d.data)
                    } else {
                        this._showToast('Failed to fetch recall feed data', { variant: 'danger' })
                        this.backToRecallList()
                        reject()
                    }
                }).catch(() => {
                    this._showToast('Error loading recall feed data', { variant: 'danger' })
                    this.backToRecallList()
                    reject()
                })
            })
        },
        mapRecallFeedToRecallItem(recallFeed) {
            this.recallItem.supplierName = recallFeed.recalling_firm || ''
            this.recallItem.communicationName = recallFeed.recall_name || ''
            this.recallItem.communicationUID = recallFeed.recall_id || ''
            this.recallItem.communicationDate = recallFeed.recall_date || ''
            this.recallItem.type = recallFeed.recall_type || ''
            this.recallItem.classification = recallFeed?.fda_classification?.split(' ')?.join('')?.toUpperCase() || 'NOT_YET_CLASSIFIED'
            this.recallItem.responseEmail = recallFeed.response_email || ''
            this.recallItem.isUrgent = recallFeed.urgent || false
            this.recallItem.markAs = 'Supplier Voluntary'
            this.recallItem.description = recallFeed.description + ' ' + recallFeed.instructions.map((ele) => ele.value).join(' ') || ''
            this.recallItem.riskToHealth = recallFeed.health_risk || ''
            this.recallItem.isCreatedFromRecallFeed = this.feedRecallSourceId ? true : false

            // Map product_list to products
            if (recallFeed.product_list && Array.isArray(recallFeed.product_list)) {
                this.recallItem.products = recallFeed.product_list.map((product, index) => {
                    const fields = []

                    // Map product fields to the expected format
                    if (product.lot_number) {
                        fields.push({
                            field_name: 'Lot Number',
                            type: 'Text',
                            value: { valueText: product.lot_number }
                        })
                    }
                    if(product.product_number){
                        fields.push({
                            field_name: 'Product Number',
                            type: 'Text',
                            value: { valueText: product.product_number }
                        })
                    }
                    if (product.serial_number) {
                        fields.push({
                            field_name: 'Serial Number',
                            type: 'Text',
                            value: { valueText: product.serial_number }
                        })
                    }
                    if (product.catalog_number) {
                        fields.push({
                            field_name: 'Catalog Number',
                            type: 'Text',
                            value: { valueText: product.catalog_number }
                        })
                    }
                    if (product.model_number) {
                        fields.push({
                            field_name: 'Model',
                            type: 'Text',
                            value: { valueText: product.model_number }
                        })
                    }
                    if (product.part_number) {
                        fields.push({
                            field_name: 'Part Number',
                            type: 'Text',
                            value: { valueText: product.part_number }
                        })
                    }
                    if (product.udi) {
                        fields.push({
                            field_name: 'UDI',
                            type: 'Text',
                            value: { valueText: product.udi }
                        })
                    }
                    if (product.ndc) {
                        fields.push({
                            field_name: 'NDC',
                            type: 'Text',
                            value: { valueText: product.ndc }
                        })
                    }
                    if (product.version) {
                        fields.push({
                            field_name: 'Version',
                            type: 'Text',
                            value: { valueText: product.version }
                        })
                    }
                    if (product.item_number) {
                        fields.push({
                            field_name: 'Item Number',
                            type: 'Text',
                            value: { valueText: product.item_number }
                        })
                    }
                    if (product.sku) {
                        fields.push({
                            field_name: 'SKU',
                            type: 'Text',
                            value: { valueText: product.sku }
                        })
                    }
                    if (product.device_size) {
                        fields.push({
                            field_name: 'Device Size',
                            type: 'Text',
                            value: { valueText: product.device_size }
                        })
                    }
                    if (product.expiration_end_date) {
                        fields.push({
                            field_name: 'Expiration End Date',
                            type: 'Date',
                            value: { valueDate: product.expiration_end_date }
                        })
                    }
                    if (product.expiration_start_date) {
                        fields.push({
                            field_name: 'Expiration Start Date',
                            type: 'Date',
                            value: { valueDate: product.expiration_start_date }
                        })
                    }
                    if (product.distribution_start_date) {
                        fields.push({
                            field_name: 'Distribution Start Date',
                            type: 'Date',
                            value: { valueDate: product.distribution_start_date }
                        })
                    }
                    if (product.distribution_end_date) {
                        fields.push({
                            field_name: 'Distribution End Date',
                            type: 'Date',
                            value: { valueDate: product.distribution_end_date }
                        })
                    }
                    if (product.manufactured_start_date) {
                        fields.push({
                            field_name: 'Manufacturing Start Date',
                            type: 'Date',
                            value: { valueDate: product.manufactured_start_date }
                        })
                    }
                    if (product.manufactured_end_date) {
                        fields.push({
                            field_name: 'Manufacturing End Date',
                            type: 'Date',
                            value: { valueDate: product.manufactured_end_date }
                        })
                    }
                    if (product.ship_date) {
                        fields.push({
                            field_name: 'Ship Date',
                            type: 'Date',
                            value: { valueDate: product.ship_date }
                        })
                    }

                    return {
                        id: null,
                        description: product.name || '',
                        fields: fields,
                        order: index + 1
                    }
                })
            }

            // Map actions to actions
            if (recallFeed.actions && Array.isArray(recallFeed.actions)) {
                this.recallItem.actions = recallFeed.actions.map((action, index) => {
                    return {
                        id: null,
                        description: action.value || '',
                        action_type: 'Text',
                        order: index + 1,
                        IsEditable: false,
                        IsDelete: true,
                        isCustomActionType: false,
                        actionValues: [{ value: '' }]
                    }
                })
            }

            // Allow editing of response email for recall feed
            this.recallItem.allowResponseEmail = true
            this.recallItem.responsestatus = ''
            this.needsEmailInitialization = true
        },
        fetchSupplierContactList()
        {
            recallService.findSupplierContacts(this.$store.state.orgId).then(resp => {
                if (!resp.error) {
                    this.SupplierContactlst = resp.data.d
                }
            })
        },
        getAutoNotifySetting()
        {
            organizationService.getAutoNotifySetting().then(resp => {
                if (!resp.error) {
                    this.autonotifychecked=resp.data.d.isautonotify
                    if(resp.data.d.isautonotify)
                    {
                        this.fetchSupplierContactList()
                    }
                }
            })
        },
        getUserSiteforRecallMeta()
        {
            var ParentOrgType=getParentOrgType()
            if(ParentOrgType=='PROVIDER' && ( this.$store.state.roleName ==='Recall Coordinator' || this.$store.state.roleName ==='Responder'))
            {
                siteService.getUserSiteforRecallMeta(this.$route.params.id).then(resp=>{
                    if(!resp.error){
                        this.recallMetaData.recall_usersites = resp.data.d
                    }
                })
            }
            if((ParentOrgType == 'NOTISPHERE' || ParentOrgType == 'PROVIDER') && (this.$store.state.roleName != 'Recall Coordinator' && this.$store.state.roleName != 'Responder')) {
                userServices.getSitesMeta(this.$store.state.orgId).then(resp => {
                    if (!resp.error) {
                        this.recallMetaData.recall_usersites = resp.data.d
                    }
                })
            }
        },
        fetchRecallItemDetail(id,providerCommunicationId) {
            return new Promise((resolve, ) => {
                recallService.getRecallById(id,providerCommunicationId).then(res => {
                    if (!res.error) {
                        this.recallItem = _.cloneDeep(res.data.d)
                        if (!this.recallItem.id || this.recallItem.id === EMPTY_GUID) {
                            this._showToast('Invalid Recall ID', {variant: 'danger'})
                            this.backToRecallList()
                        } else {
                            this.fetchRecallMetaDataFromRecallItem(this.recallItem)
                            resolve(true)
                        }
                    }
                })
            })

        },
        fetchRecallMetaDataFromRecallItem(item) {
            if (item && item.meta_data) {
                let _lookupValues = item.meta_data.lookup_values
                let _productFields = item.meta_data.product_fields

                let _recall_types = _lookupValues.find(x => x.name === 'Recall Type')
                if (_recall_types) {
                    this.recallMetaData.recall_types = _recall_types.list_vals
                }

                let _recall_categories = _lookupValues.find(x => x.name === 'Recall Categories')
                if (_recall_categories) {
                    this.recallMetaData.recall_categories = _recall_categories.list_vals
                }

                let _recall_mark_as = _lookupValues.find(x => x.name === 'Recall Mark As')
                if (_recall_mark_as) {
                    this.recallMetaData.recall_mark_as = _recall_mark_as.list_vals
                    if (this.recallMetaData.recall_mark_as && this.recallMetaData.recall_mark_as.length > 0) {
                        this.recallItem.markAs = this.recallMetaData.recall_mark_as[0].value
                    }
                }

                if (_productFields) {
                    this.recallMetaData.recall_product_fields = _productFields
                }
            }
        },
        fetchRecallMetaDataFromService() {
            recallService.getRecallMetaData().then(res => {
                if (!res.error) {
                    let _lookupValues = res.data.d.lookup_values

                    let _recall_types = _lookupValues.find(x => x.name === 'Recall Type')
                    if (_recall_types) {
                        this.recallMetaData.recall_types = _recall_types.list_vals
                    }

                    let _recall_categories = _lookupValues.find(x => x.name === 'Recall Categories')
                    if (_recall_categories) {
                        this.recallMetaData.recall_categories = _recall_categories.list_vals
                    }

                    let _recall_mark_as = _lookupValues.find(x => x.name === 'Recall Mark As')
                    if (_recall_mark_as) {
                        this.recallMetaData.recall_mark_as = _recall_mark_as.list_vals
                        if (this.recallMetaData.recall_mark_as && this.recallMetaData.recall_mark_as.length > 0) {
                            this.recallItem.markAs = this.recallMetaData.recall_mark_as[0].value
                        }
                    }
                }
            }).finally(() => {
                this.initialLoading = false
            })
        },
        fetchProviderCommunicationId(){
            return new Promise((resolve, reject) => {
                recallService.getProviderCommunicationId(this.communicationId, null).then(resp => {
                    if (!resp.error) {
                        this.providerCommunicationId = resp.data.d
                        resolve(true)
                    } else {
                        reject(false)
                    }
                })
            })
        },
        nextStep() {
            if (this.currentStep < 2) {
                localStorage.setItem('savedStep', this.currentStep)
                this.currentStep += 1
            }
        },
        previousStep() {
            if (this.currentStep > 0) {
                this.currentStep -= 1
            }
        },
        changeStep(step) {
            if (!isNaN(step) && step >= 0 && step <= 2 && this.currentStep !== step) {
                localStorage.setItem('savedStep', this.currentStep)
                this.currentStep = step
            }
        },
        backToRecallList() {
            this.$router.push({
                name: this.recallSupplierListPathName
            })
        },
        exit() {
            this.isAutoPopulateEditInProgress = false
            if (this.recallMode == 'EDIT') {
                this.showChangeHistoryModal()
            } else {
                this.backToViewRecall()
            }
            if (this.recallItem.id || !this.recallItem.id === EMPTY_GUID) {
                this.updateEvent()
            }
        },
        backToViewRecall() {
            if(this.communicationId && this.providerCommunicationId){
                this.$router.push({ name: 'prov_RecallView', params: { id: this.communicationId, providerCommunicationId: this.providerCommunicationId, communicationType: this.communicationType} })
            } else{
                this.backToRecallList()
            }
        },
        draft() {
            this.isAutoPopulateEditInProgress = false
            if (this.recallMode == 'EDIT') {
                this.buttonType = 'DRAFT'
                this.showChangeHistoryModal()
            } else {
                this.backToRecallList()
            }
            if (this.recallItem.id || !this.recallItem.id === EMPTY_GUID) {
                this.updateEvent()
            }
        },
        updateEvent() {
            recallService.updateEvent(this.recallItem.id)
        },
        showChangeHistoryModal() {
            this.changeHistoryModalKey += 1
            this.$nextTick(() => {
                this.$refs.changeHistoryModal.forceRerender(this.recallItem.id, this.communicationType)
            })
        },
        onSavedHistory() {
            if(this.buttonType === 'DRAFT') {
                this.buttonType = ''
                this.backToRecallList()
            } else {
                this.backToViewRecall()
            }
        },

        updateRecallStatus(data, status) {
            const recallId = data?.id || data?._id || data
            if (!recallId) {
                console.error('No recall ID found for status update')
                return
            }
            // Update status in backend
            recallsFeedServices.updateRecallFeedStatus(recallId, status, null).then(resp => {
                if (resp && !resp.error) {
                    // Update the local data
                    data.review_status = status
                    // Refresh the grid to show updated status
                    if (this.gridApi) {
                        this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
                    }
                } else {
                    console.error('Failed to update recall status:', resp)
                }
            }).catch(error => {
                console.error('Error updating recall status:', error)
            })
        },

        saveAllRecallData(goTypeFn, step, name, recallMode, isNavigateAway = false) {
            return this.saveStep0Info(step, name, recallMode, true, true)
                .then(resp => {
                    if (resp) {
                        return supplierRecallService.saveCommunicationStep1Products({
                            id: this.communicationId,
                            communicationType: this.communicationType,
                            products: this.recallItem.products,
                            clicktype: name,
                            updateStep0: '',
                            isEditMode: this.recallMode === 'EDIT',
                            aiRecallJobId: this.aiRecallJobId,
                        })
                    }
                })
                .then(step1Resp => {
                    if (step1Resp && !step1Resp.error) {
                        return supplierRecallService.saveCommunicationStep2Actions({
                            id: this.communicationId,
                            communicationType: this.communicationType,
                            actions: this.recallItem.actions,
                            clicktype: name,
                            isEditMode: this.recallMode === 'EDIT',
                            aiRecallJobId: this.aiRecallJobId,
                        })
                    }
                })
                .then(step2Resp => {
                    if (step2Resp && !step2Resp.error) {
                        goTypeFn(step)
                        if (isNavigateAway) {
                            return this.communicationId
                        }
                        localStorage.setItem('autoPopulateRecallId', this.communicationId)
                        this.isAiRecallSaved = true
                        localStorage.removeItem('RecallFeedSourceId')
                        return this.fetchProviderCommunicationId().then(() => {
                            if(name === 'bound nextStep' || name === 'bound changeStep') {
                                this.$router.push({
                                    name: this.recallEditPathName,
                                    params: { id: this.communicationId, step: this.currentStep, aiRecallJobId: this.aiRecallJobId, recallFeedSourceId: this.feedRecallSourceId,  isAiRecallSaved: this.isAiRecallSaved }
                                })
                            } else {
                                this.backToViewRecall()
                            }
                            return this.communicationId
                        })
                    }
                })
                .catch(() => {
                    this.loading = false
                })
        },

        saveAndGo(goTypeFn, step = null) {
            if ((this.feedRecallSourceId || this.aiRecallJobId) && this.currentStep === 0 && !this.isAiRecallSaved) {
                return this.saveAllRecallData(goTypeFn, step, goTypeFn.name, this.recallMode)
            }
            if (this.currentStep === 0) {
                this.saveStep0Info(step, goTypeFn.name, this.recallMode).then(resp => {
                    if (resp) {
                        goTypeFn(step)
                        this.loading = false
                        const RecallFeedId = localStorage.getItem('RecallFeedId')
                        if (RecallFeedId) {
                            localStorage.removeItem('RecallFeedId')
                            this.updateRecallStatus(RecallFeedId, 'CREATED')
                        }
                    }
                }).catch(() => {
                    this.loading = false
                })
            } else if (this.currentStep === 1) {
                this.saveStep1Products(goTypeFn.name, this.recallMode, {aiRecallJobId: this.aiRecallJobId}).then(resp => {
                    if (resp) {
                        goTypeFn(step)
                        if (this.feedRecallSourceId) {
                            this.fetchRecallFeedData(this.feedRecallSourceId).then(recallFeed => {
                                this.mapRecallFeedToRecallItem(recallFeed.recall_info)
                            })
                        }
                        this.loading = false
                    }
                }).catch(() => {
                    this.loading = false
                })
            } else if (this.currentStep === 2) {
                this.saveStep2Actions(goTypeFn.name, this.recallMode, {aiRecallJobId: this.aiRecallJobId}).then(resp => {
                    if (resp) {
                        goTypeFn(step)
                        this.loading = false
                    }
                }).catch(() => {
                    this.loading = false
                })
            } else {
                goTypeFn(step)
            }
        },

        saveStep0Info(step, type, mode, skipNavigation = false, isSaveAll = false) {
            if(step===null)
            {step=1}
            return new Promise((resolve, reject) => {
                if (!this.isDisabled) {
                    this.$refs.step0Info.save(type, mode, {
                        aiRecallJobId: this.aiRecallJobId,
                    }).then(resp => {
                        if (resp) {
                            this.communicationId = resp
                            if (this.routeFormType === 'CREATE' && !skipNavigation) {
                                this.fetchProviderCommunicationId().then((res) => {
                                    this.$router.push({
                                        name: this.recallEditPathName,
                                        params: { id: resp, step: step  }
                                    })
                                    resolve(true)
                                })
                            } else if (this.routeFormType === 'CREATE' && skipNavigation) {
                                this.routeFormType = 'EDIT'
                                resolve(true)
                            } else {
                                this.loading = true
                                var providerCommunicationId=this.$route.params.providerCommunicationId==undefined?0:this.$route.params.providerCommunicationId
                                this.fetchRecallItemDetail(resp,providerCommunicationId).then(res => {
                                    if (res) {
                                        resolve(true)
                                    }
                                })
                            }
                        }
                    }).catch(error => {
                        reject(error)
                    })
                } else {
                    resolve(true)
                }
            })
        },
        saveStep1Products(type, mode) {
            return new Promise((resolve, reject) => {
                if (!this.isDisabled) {
                    this.$refs.step1Products.save(type, mode, {
                        aiRecallJobId: this.aiRecallJobId
                    }).then(resp => {
                        if (resp) {
                            this.communicationId = resp
                            this.fetchProviderCommunicationId().then((res) => {
                                this.loading = true
                                var providerCommunicationId=this.$route.params.providerCommunicationId==undefined?0:this.$route.params.providerCommunicationId
                                this.fetchRecallItemDetail(resp,providerCommunicationId).then(res => {
                                    if (res) {
                                        resolve(true)
                                    }
                                })
                            })
                        }
                    }).catch(error => {
                        reject(error)
                    })
                } else {
                    resolve(true)
                }
            })
        },
        saveStep2Actions(type, mode) {
            return new Promise((resolve, reject) => {
                if (!this.isDisabled) {
                    this.$refs.step2Actions.save(type, mode, {
                        aiRecallJobId: this.aiRecallJobId
                    }).then(resp => {
                        if (resp) {
                            this.communicationId = resp
                            this.fetchProviderCommunicationId().then((res) => {
                                this.loading = true
                                var providerCommunicationId=this.$route.params.providerCommunicationId==undefined?0:this.$route.params.providerCommunicationId
                                this.fetchRecallItemDetail(resp,providerCommunicationId).then(res => {
                                    if (res) {
                                        resolve(true)
                                    }
                                })
                            })

                        }
                    }).catch(error => {
                        reject(error)
                    })
                } else {
                    resolve(true)
                }
            })
        },
        getRecallAIByJobId(jobId) {
            return recallService.getRecallAIByJobId(jobId).then(resp => {
                if (!resp.error) {
                }
            })
        }
    }
}